import { PublishCourse } from "../publishCourse"

export const PublishWorkForce = ({ publish, pageSwap }) => {
    return(
        <PublishCourse
            pageSwap={pageSwap}
            customerStage={5}
        />

    )
}